import { CONTACT_EMAIL } from "../../../helpers/constants";
import { PAYMENT_STRINGS } from "../../private/payment-result/strings";
import SuccessIcon from "../../private/payment-result/success-icon";
import PublicLayout from "../../../layout/public-layout";

const strings = PAYMENT_STRINGS.successGuest;

const PaymentSuccessGuest = () => {
  // No authenticated fetch is made here (guest checkout has no session);
  // this page shows a generic message without payment details.
  return (
    <PublicLayout>
      <div className="gm-clients-details-container">
        <div style={{ maxWidth: 440, margin: "40px auto", padding: "0 24px 32px", display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SuccessIcon />
          {/* Title */}
          <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 6, textAlign: "center", color: "#1a1a1a" }}>{strings.title}</h2>

          {/* Body */}
          <p style={{ color: "#999", fontSize: 14, marginBottom: 16, textAlign: "center" }}>{strings.description}</p>

          {/* Contact line */}
          <p style={{ color: "#999", fontSize: 14, textAlign: "center" }}>
            {strings.contactPrefix}
            <a href={`mailto:${CONTACT_EMAIL}`}>{strings.contactLinkLabel}</a>
          </p>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PaymentSuccessGuest;
